import styled from 'styled-components'

export const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const ButtonBlock = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;

  button {
    margin-right: 20px;
  }
`

export const Estimated = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  padding: 2rem;
  margin-bottom: 2rem;
`
export const EstimateTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #152735;
  margin-bottom: 0.5rem;
`
export const EstimatePrice = styled.p`
  font-size: 24px;
  color: #152735;
`
export const Label = styled.p`
  height: 18px;
  width: 80px;
  color: #89919c;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 18px;
`
export const Value = styled.p`
  color: #152735;
  font-size: 21px;
  font-weight: bold;
  word-break: break-all;
`
export const TitleBlock = styled.div`
  margin-bottom: 3rem;
  width: 100%;
  border-bottom: 1px solid #eeeeee;

  h1 {
    margin-bottom: 1rem;
  }

  h3 {
    color: #585d64;
    margin-bottom: 2.5rem;
  }
`

export const RightHeadTitle = styled.div`
  display: flex;
  flex-direction: row;

  button {
    margin-left: 30px;
    min-width: auto;
  }
`

export const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`
